import { apiInstance } from "@/services/httpAdapter";
import { errorLogger } from "./logger";

export async function getObjectLink(presignedURL: string, contentType: string) {
	if (presignedURL && contentType) {
		try {
			const response = await apiInstance.get(presignedURL);
			const successStatus = 200;
			if (response.status === successStatus) {
				const arrayBuffer = await response.arrayBuffer();
				const dataBlob = new Blob([arrayBuffer], { type: contentType });
				return URL.createObjectURL(dataBlob);
			} else {
				errorLogger(`Error: ${response.status} ${response.statusText}`);
			}
		} catch (error) {
			errorLogger(error as Error);
		}
	}
	return null;
}
